<div class="forbidden-content">
    <div class="icon">
        <i class="ph-fill ph-warning-circle"></i>
    </div>
    <div class="content">
        <span class="title">{{ 'doktar_app.common_errors.someting_went_wrong_title' | translate }}</span>
        <span class="description">{{ 'doktar_app.common_errors.someting_went_wrong_description' | translate }}</span>
    </div>
    <div class="buttons">
        <dk-button [label]="'doktar_app.common.got_it_thanks_button' | translate" severity="primary" (onClick)="close()"></dk-button>
    </div>
</div>